module.exports = __webpack_public_path__ + "media/images/riders/MARK_WALLACE-1b3dddff29a28f3f9d97171b6fe0b240.png";